import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useUserStatuses } from "./UserStatusContext";
import { initSocket } from "./websocket";

const SocketInit = () => {
  const user = useSelector((state: any) => state.user);
  const { setUserStatuses } = useUserStatuses();

  useEffect(() => {
    if (user?.currentUser?.id) {
      const socket = initSocket(user.currentUser.id, setUserStatuses);
      return () => {
        if (socket) socket.disconnect();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.currentUser?.id]);

  return null;
};

export default SocketInit;
